// extracted by css-extract-rspack-plugin
export default {"settings":"settings--SNXycV016WgFlYLU","group":"group--hePkQ6J3vVs71wj9"};